exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner-tips[data-v-043904e4]{font-size:12px;color:#ff0000;line-height:20px}\n", ""]);

// exports
